import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getUserManagement = createAsyncThunk(
  "admin/user-management",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/user-management", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getUserManagementById = createAsyncThunk(
  "admin/user-management/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/user-management/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortUserManagement = createAsyncThunk(
  "admin/user-management/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/user-management/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postUserManagement = createAsyncThunk(
  "admin/user-management/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/user-management", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteUserManagement = createAsyncThunk(
  "admin/user-management/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/user-management/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateUserManagement = createAsyncThunk(
  "admin/user-management/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/user-management/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const changePasswordUserManagement = createAsyncThunk(
  "admin/user-management/change-password",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/user-management/change-password",
        data.token,
        "",
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const userManagementSlice = createSlice({
  name: "User Management Store",
  initialState: initialState,
  reducers: {
    addUserManagement(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortUserManagement(state, action) {
      state.data.docs = action.payload;
    },
    deleteUserManagement(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editUserManagement(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getUserManagement.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getUserManagement.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getUserManagement.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getUserManagementById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getUserManagementById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getUserManagementById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortUserManagement.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortUserManagement.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortUserManagement.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postUserManagement.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postUserManagement.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postUserManagement.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteUserManagement.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteUserManagement.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteUserManagement.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateUserManagement.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateUserManagement.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateUserManagement.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
    [changePasswordUserManagement.pending]: (state, ) => {
      state.isLoading = true;
    },
    [changePasswordUserManagement.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [changePasswordUserManagement.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const userManagementActions = userManagementSlice.actions;

export default userManagementSlice.reducer;
